<template>
  <v-tabs v-model="tabs">
    <v-tab :key="1">{{ labels.general }}</v-tab>
    <v-tab-item :key="1">
      <v-card flat>
        <v-toolbar dense color="grey lighten-5" flat>
          <v-icon>mdi-format-align-justify</v-icon>
          <v-toolbar-title class="toolbar-title-2">{{ labels.details }}</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <v-container fluid grid-list-sm>
            <v-layout row wrap>
              <v-flex md2 xs12 v-if="newInsured">
                <v-checkbox :label="labels.insdRefNoAe" v-model="insuredForm.insdRefNoAe" @change="doInsdRefNoAe"></v-checkbox>
              </v-flex>
              <v-flex md4 xs12 v-else>
                <v-checkbox :label="labels.insdRefNoAe" v-model="insuredForm.insdRefNoAe" disabled></v-checkbox>
              </v-flex>
              <v-flex md2 xs12 v-if="newInsured">
                <v-flex v-if="!insuredForm.insdRefNoAe">
                  <v-text-field
                    :label="labels.insdRefNo"
                    v-model="insuredForm.insdRefNo"
                    :error-messages="errors.collect('insdRefNo')"
                    v-validate="'required|param|max:8'"
                    data-vv-name="insdRefNo"
                    :data-vv-as="labels.insdRefNo"
                  ></v-text-field>
                </v-flex>
              </v-flex>
              <v-flex md4 xs12>
                <v-select
                  :items="insuredClientGrpList"
                  v-model="insuredForm.clientGrp"
                  :label="labels.clientGrp"
                  item-text="label"
                  item-value="value"
                  data-vv-name="clientGrp"
                  :data-vv-as="labels.clientGrp"
                  :error-messages="errors.collect('clientGrp')"
                  @change="doClientGrp"
                ></v-select>
              </v-flex>
              <!--AR: Commented as per PMO 02-Feb-2021 action item
              <v-flex md4 xs12 v-if="newInsured">
                <v-select :items="insuredClientGrpList" v-model="insuredForm.clientGrp" :label="labels.clientGrp" item-text="label" item-value="value" data-vv-name="clientGrp" :data-vv-as="labels.clientGrp" :error-messages="errors.collect('clientGrp')" @change="doClientGrp"></v-select>
              </v-flex>
              <v-flex md4 xs12 v-else>
                <v-select :items="insuredClientGrpList" v-model="insuredForm.clientGrp" :label="labels.clientGrp" item-text="label" item-value="value" data-vv-name="clientGrp" :data-vv-as="labels.clientGrp" :error-messages="errors.collect('clientGrp')" @change="doClientGrp" disabled></v-select>
              </v-flex> -->
              <v-flex md4 xs12>
                <v-autocomplete
                  :label="labels.clientType"
                  v-model="insuredForm.clientType"
                  :items="clientTypeList"
                  item-text="label"
                  item-value="value"
                  data-vv-name="clientType"
                  :data-vv-as="labels.clientType"
                  :error-messages="errors.collect('clientType')"
                  v-validate="'required'"
                ></v-autocomplete>
              </v-flex>
              <v-flex md2 xs12>
                <v-select
                  :items="insuredTitleList"
                  v-model="insuredForm.titleName"
                  :label="labels.titleName"
                  item-text="label"
                  item-value="value"
                  data-vv-name="titleName"
                  :data-vv-as="labels.titleName"
                  :error-messages="errors.collect('titleName')"
                ></v-select>
              </v-flex>
              <!-- Name 1 - 4 -->
              <v-flex md3 xs12>
                <v-text-field
                  :label="labels.name1"
                  v-model="insuredForm.name1"
                  :error-messages="errors.collect('name1')"
                  v-validate="'required|entry|max:60|sanction:' + sanctionName1Error"
                  @change="valSanction(insuredForm.name1, '', 'sanctionName1Error')"
                  data-vv-name="name1"
                  :data-vv-as="labels.name1"
                ></v-text-field>
              </v-flex>
              <v-flex md3 xs12>
                <v-text-field
                  :label="labels.name2"
                  v-model="insuredForm.name2"
                  :error-messages="errors.collect('name2')"
                  v-validate="'entry|max:300|sanction:' + sanctionName2Error"
                  @change="valSanction(insuredForm.name2, '', 'sanctionName2Error')"
                  data-vv-name="name2"
                  :data-vv-as="labels.name2"
                ></v-text-field>
              </v-flex>
              <v-flex md3 xs12>
                <v-text-field
                  :label="labels.name3"
                  v-model="insuredForm.name3"
                  :error-messages="errors.collect('name3')"
                  v-validate="'entry|max:300|sanction:' + sanctionName3Error"
                  @change="valSanction(insuredForm.name3, '', 'sanctionName3Error')"
                  data-vv-name="name3"
                  :data-vv-as="labels.name3"
                ></v-text-field>
              </v-flex>
              <v-flex md4 xs12>
                <v-text-field
                  :label="labels.postalCode"
                  v-model="insuredForm.postalCode"
                  v-int-mask="{ intScale: 8 }"
                  type="tel"
                  :error-messages="errors.collect('postalCode')"
                  v-validate="'numeric|max:8'"
                  data-vv-name="postalCode"
                  :data-vv-as="labels.postalCode"
                  :loading="InsuredPostalCodeLoading"
                  @change="doInsuredAddress"
                ></v-text-field>
              </v-flex>
              <v-flex md4 xs12>
                <v-text-field
                  :label="labels.address1"
                  v-model="insuredForm.address1"
                  :error-messages="errors.collect('address1')"
                  v-validate="'entry|max:60'"
                  data-vv-name="address1"
                  :data-vv-as="labels.address1"
                ></v-text-field>
              </v-flex>
              <v-flex md4 xs12>
                <v-text-field
                  :label="labels.address2"
                  v-model="insuredForm.address2"
                  :error-messages="errors.collect('address2')"
                  v-validate="'entry|max:60'"
                  data-vv-name="address2"
                  :data-vv-as="labels.address2"
                ></v-text-field>
              </v-flex>
              <v-flex md4 xs12>
                <v-text-field
                  :label="labels.address3"
                  v-model="insuredForm.address3"
                  :error-messages="errors.collect('address3')"
                  v-validate="'entry|max:60'"
                  data-vv-name="address3"
                  :data-vv-as="labels.address3"
                ></v-text-field>
              </v-flex>
              <v-flex md4 xs12>
                <v-text-field
                  :label="labels.address4"
                  v-model="insuredForm.address4"
                  :error-messages="errors.collect('address4')"
                  v-validate="'entry|max:60'"
                  data-vv-name="address4"
                  :data-vv-as="labels.address4"
                ></v-text-field>
              </v-flex>
              <v-flex xs4>
                <v-text-field
                  :label="labels.abbrevName"
                  v-model="insuredForm.abbrevName"
                  :error-messages="errors.collect('abbrevName')"
                  v-validate="'entry|max:20'"
                  data-vv-name="abbrevName"
                  :data-vv-as="labels.abbrevName"
                ></v-text-field>
              </v-flex>
              <v-flex md4 xs12>
                <v-text-field
                  :label="labels.contact"
                  v-model="insuredForm.contact"
                  :error-messages="errors.collect('contact')"
                  v-validate="'entry|max:60'"
                  data-vv-name="contact"
                  :data-vv-as="labels.contact"
                ></v-text-field>
              </v-flex>
              <v-flex md4 xs12>
                <v-text-field
                  :label="labels.telNo1"
                  v-model="insuredForm.telNo1"
                  type="tel"
                  :error-messages="errors.collect('telNo1')"
                  v-validate="'entry|max:20'"
                  data-vv-name="telNo1"
                  :data-vv-as="labels.telNo1"
                ></v-text-field>
              </v-flex>
              <v-flex md4 xs12>
                <v-text-field
                  :label="labels.telNo2"
                  v-model="insuredForm.telNo2"
                  type="tel"
                  :error-messages="errors.collect('telNo2')"
                  v-validate="'entry|max:20'"
                  data-vv-name="telNo2"
                  :data-vv-as="labels.telNo2"
                ></v-text-field>
              </v-flex>
              <v-flex md4 xs12>
                <v-text-field
                  :label="labels.telNo3"
                  v-model="insuredForm.telNo3"
                  type="tel"
                  :error-messages="errors.collect('telNo3')"
                  v-validate="'entry|max:20'"
                  data-vv-name="telNo3"
                  :data-vv-as="labels.telNo3"
                ></v-text-field>
              </v-flex>
              <v-flex md4 xs12>
                <v-text-field
                  :label="labels.telNo4"
                  v-model="insuredForm.telNo4"
                  type="tel"
                  :error-messages="errors.collect('telNo4')"
                  v-validate="'entry|max:20'"
                  data-vv-name="telNo4"
                  :data-vv-as="labels.telNo4"
                ></v-text-field>
              </v-flex>
              <v-flex md4 xs12>
                <v-text-field
                  v-model="insuredForm.email"
                  :label="labels.email"
                  :error-messages="errors.collect('email')"
                  data-vv-name="email"
                  :data-vv-as="labels.email"
                  v-validate="'email|max:50'"
                ></v-text-field>
              </v-flex>
              <v-flex md4 xs12>
                <v-text-field
                  :label="labels.web"
                  v-model="insuredForm.web"
                  :error-messages="errors.collect('web')"
                  v-validate="'entry|max:40'"
                  data-vv-name="web"
                  :data-vv-as="labels.web"
                ></v-text-field>
              </v-flex>
              <v-flex md4 xs12 v-if="!newInsured">
                <v-subheader class="queryLabel">{{ labels.createdBy }}</v-subheader>
                <div class="queryValue">
                  {{ insuredForm.createdBy }} on {{ formatDate(insuredForm.createdDate) }} by {{ insuredForm.createdProgId }}
                </div>
              </v-flex>
              <v-flex md4 xs12 v-if="!newInsured">
                <v-subheader class="queryLabel">{{ labels.modifiedBy }}</v-subheader>
                <div class="queryValue">{{ insuredForm.modifiedBy }} on {{ formatDate(insuredForm.modifiedDate) }}</div>
              </v-flex>
              <v-flex xs12>
                <v-expansion-panels v-model="panel" multiple>
                  <v-expansion-panel :disabled="boolClientGrpI">
                    <v-expansion-panel-header>
                      <div><v-icon>mdi-plus</v-icon><span class="headerTitle">Individual</span></div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-card-text>
                        <v-container fluid grid-list-sm>
                          <v-layout row wrap>
                            <v-flex md4 xs12>
                              <v-select
                                :items="insuredGenderList"
                                v-model="insuredForm.gender"
                                :label="labels.gender"
                                item-text="label"
                                item-value="value"
                                data-vv-name="gender"
                                :data-vv-as="labels.gender"
                                :error-messages="errors.collect('gender')"
                              ></v-select>
                            </v-flex>
                            <v-flex md4 xs12>
                              <cal-picker
                                :label="labels.dob"
                                :selected-date="selectedDate"
                                v-model="insuredForm.dob"
                                :error-messages="errors.collect('dob')"
                                data-vv-name="dob"
                                :data-vv-as="labels.dob"
                              ></cal-picker>
                            </v-flex>
                            <v-flex md4 xs12>
                              <v-text-field
                                v-model="insuredForm.icNo"
                                :label="labels.icNo"
                                :error-messages="errors.collect('icNo')"
                                data-vv-name="icNo"
                                :data-vv-as="labels.icNo"
                                v-validate="'alpha_num|max:20|sanction:' + sanctionDocNoError"
                                @change="valIcNo"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel :disabled="boolClientGrpC">
                    <v-expansion-panel-header>
                      <div><v-icon>mdi-plus</v-icon><span class="headerTitle">Corporation</span></div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-card-text>
                        <v-container fluid grid-list-sm>
                          <v-layout row wrap>
                            <v-flex md6 xs12>
                              <v-text-field
                                :label="labels.coRegNo"
                                v-model="insuredForm.coRegNo"
                                :error-messages="errors.collect('coRegNo')"
                                v-validate="'entry|max:20'"
                                data-vv-name="coRegNo"
                                :data-vv-as="labels.coRegNo"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md6 xs12>
                              <cal-picker
                                :label="labels.coRegDate"
                                v-model="insuredForm.coRegDate"
                                :error-messages="errors.collect('coRegDate')"
                                data-vv-name="coRegDate"
                                :data-vv-as="labels.coRegDate"
                                v-validate="startDateValidation"
                              ></cal-picker>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      <div><v-icon>mdi-plus</v-icon><span class="headerTitle">Other details and settings</span></div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-card-text>
                        <v-container fluid grid-list-sm>
                          <v-layout row wrap>
                            <v-flex md4 xs12>
                              <v-text-field
                                :label="labels.gstRegNo"
                                v-model="insuredForm.gstRegNo"
                                :error-messages="errors.collect('gstRegNo')"
                                v-validate="'entry|max:20'"
                                data-vv-name="gstRegNo"
                                :data-vv-as="labels.gstRegNo"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md4 xs12>
                              <cal-picker
                                :label="labels.gstRegDate"
                                v-model="insuredForm.gstRegDate"
                                :error-messages="errors.collect('gstRegDate')"
                                data-vv-name="gstRegDate"
                                :data-vv-as="labels.gstRegDate"
                                v-validate="gstDateValidation"
                              ></cal-picker>
                            </v-flex>
                            <v-flex md4 xs12>
                              <v-autocomplete
                                :label="labels.insdBillAcct"
                                v-model="insuredForm.insdBillAcct"
                                :items="interList"
                                item-text="label"
                                item-value="value"
                                data-vv-name="insdBillAcct"
                                :data-vv-as="labels.insdBillAcct"
                                :error-messages="errors.collect('insdBillAcct')"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex md4 xs12>
                              <v-checkbox :label="labels.inactive" v-model="insuredForm.inactive"></v-checkbox>
                            </v-flex>
                            <v-flex md4 xs12>
                              <v-checkbox :label="labels.blackList" v-model="insuredForm.blackList"></v-checkbox>
                            </v-flex>
                            <v-flex md4 xs12>
                              <v-checkbox :label="labels.chgNAPol" v-model="insuredForm.chgNAPol"></v-checkbox>
                            </v-flex>
                            <v-flex md4 xs12>
                              <v-text-field
                                v-model="insuredForm.grpRefStmt"
                                :label="labels.grpRefStmt"
                                :error-messages="errors.collect('grpRefStmt')"
                                data-vv-name="grpRefStmt"
                                :data-vv-as="labels.grpRefStmt"
                              >
                                <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                  <v-icon color="info" @click="doShowInsuredList('GS1')" v-text="'mdi-magnify'"></v-icon>
                                </v-slide-x-reverse-transition>
                              </v-text-field>
                            </v-flex>
                            <v-flex md4 xs12>
                              <v-text-field
                                v-model="insuredForm.grpRefAge"
                                :label="labels.grpRefAge"
                                :error-messages="errors.collect('grpRefAge')"
                                data-vv-name="grpRefAge"
                                :data-vv-as="labels.grpRefAge"
                              >
                                <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                  <v-icon color="info" @click="doShowInsuredList('GA1')" v-text="'mdi-magnify'"></v-icon>
                                </v-slide-x-reverse-transition>
                              </v-text-field>
                            </v-flex>
                            <v-flex md4 xs12>
                              <v-text-field
                                v-model="insuredForm.grpRefStats"
                                :label="labels.grpRefStats"
                                :error-messages="errors.collect('grpRefStats')"
                                data-vv-name="grpRefStats"
                                :data-vv-as="labels.grpRefStats"
                              >
                                <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                  <v-icon color="info" @click="doShowInsuredList('GS2')" v-text="'mdi-magnify'"></v-icon>
                                </v-slide-x-reverse-transition>
                              </v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-flex>
              <v-flex lg6 md12 xs12>
                <v-card-actions>
                  <v-btn class="white--text error" @click.prevent="doBack">
                    Cancel
                    <v-icon right>mdi-cancel</v-icon>
                  </v-btn>
                  <v-btn v-show="newInsured" color="primary" type="submit" :loading="submitting" @click.prevent="doSave">
                    Save
                    <v-icon right>mdi-content-save</v-icon>
                  </v-btn>
                  <v-btn v-show="!newInsured" color="primary" type="submit" :loading="submitting" @click.prevent="doPromptSave">
                    Save
                    <v-icon right>mdi-content-save</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-flex>
              <confirm v-model="promptPostalCode" @cancel="doCancelPostalCode"> Is the postal code correct? </confirm>
              <confirm v-model="promptSave" @ok="doSave"> Are you sure you want to save your changes? </confirm>
              <confirm v-model="promptIcNo" @cancel="doCancelIcNo"> Is the NRIC correct? </confirm>
              <v-dialog v-model="showInsuredHelpList" width="1280px">
                <insured-help-list
                  :insuredFieldKey="insuredFieldKey"
                  @close="showInsuredHelpList = false"
                  @assign-insured-info="assignInsuredInfo"
                ></insured-help-list>
              </v-dialog>
            </v-layout>

            <!--LYT Added: 2020-08-27  Sanction Partial Matched Names List -->
            <v-dialog v-model="showSanctionDialog" width="1280px">
              <sanction-partial-match-list
                :sanctionItems="sanctionPartialMatchItems"
                @close="showSanctionDialog = false"
              ></sanction-partial-match-list>
            </v-dialog>
          </v-container>
        </v-card-text>
      </v-card>
    </v-tab-item>
  </v-tabs>
</template>

<script>
import { insuredTitle, insuredClientGrp, insuredGender } from '@/const/underwriting'
import { mapGetters, mapActions } from 'vuex'
import { expandURI } from '@/utils/ajax'
import MessageMixin from '@/mixins/message'
import { formatDisplayDate } from '@/utils/date'
import InsuredHelpList from '@/components/core/common/dialog/InsuredHelpList'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import SanctionPartialMatchList from '@/components/core/common/dialog/SanctionPartialMatchList'

export default {
  data() {
    return {
      tabs: 0,
      panel: [0],
      labels: {
        general: 'General',
        details: 'Details',
        insdRefNoAe: 'Auto generate Insured Reference',
        insdRefNo: 'Insured Reference*',
        clientGrp: 'Client Group',
        clientType: 'Client Type*',
        titleName: 'Title',
        name1: 'Name 1*',
        name2: 'Name 2',
        name3: 'Name 3',
        name4: 'Name 4',
        fullName: 'Full Name*',
        postalCode: 'Postal Code',
        address1: 'Address 1',
        address2: 'Address 2',
        address3: 'Address 3',
        address4: 'Address 4',
        address5: 'State',
        address6: 'Country*',
        abbrevName: 'Abbreviated Name',
        contact: 'Contact Name',
        telNo1: 'Home No.',
        telNo2: 'Office No.',
        telNo3: 'Mobile No.',
        telNo4: 'Fax No.',
        email: 'Email',
        web: 'Web page',
        gender: 'Gender',
        dob: 'Birthday',
        icNo: 'NRIC',
        coRegNo: 'Company Registration No.',
        coRegDate: 'Registration Date',
        gstRegNo: 'GST Registration No.',
        gstRegDate: 'GST Registration Date',
        inactive: 'Insured is Inactive',
        blackList: 'Insured is Blacklisted',
        chgNAPol: 'Allow Change in Policy',
        insdBillAcct: 'Default Billing Account No.',
        grpRefStmt: 'Group Statement Insured Reference',
        grpRefAge: 'Group Ageing Insured No.',
        grpRefStats: 'Group Statistics Insured Reference',
        createdBy: 'Created by',
        createdDate: 'Created Date',
        modifiedBy: 'Modified by',
        modifiedDate: 'Modified Date'
      },
      insuredForm: {
        insdRefNoAe: true,
        insdRefNo: undefined,
        clientGrp: 'I',
        clientType: undefined,
        titleName: undefined,
        name1: undefined,
        name2: undefined,
        name3: undefined,
        name4: undefined,
        fullName: undefined,
        postalCode: undefined,
        address1: undefined,
        address2: undefined,
        address3: undefined,
        address4: undefined,
        abbrevName: undefined,
        contact: undefined,
        telNo1: undefined,
        telNo2: undefined,
        telNo3: undefined,
        telNo4: undefined,
        email: undefined,
        web: undefined,
        gender: 'N',
        dob: undefined,
        icNo: undefined,
        coRegNo: undefined,
        coRegDate: undefined,
        gstRegNo: undefined,
        gstRegDate: undefined,
        inactive: false,
        blackList: false,
        chgNAPol: false,
        insdBillAcct: undefined,
        grpRefStmt: undefined,
        grpRefAge: undefined,
        grpRefStats: undefined,
        createdBy: undefined,
        createdDate: undefined,
        createdProgId: undefined,
        modifiedBy: undefined,
        modifiedDate: undefined
      },
      insuredCountryList: [],
      clientTypeList: [],
      insuredList: [],
      interList: [],
      menu: [],
      newInsured: false,
      boolClientGrpI: false,
      boolClientGrpC: false,
      submitting: false,
      InsuredPostalCodeLoading: false,
      selectedDate: new Date(new Date().getFullYear(), 11, 31),
      promptPostalCode: false,
      promptIcNo: false,
      showInsuredHelpList: false,
      insuredFieldKey: '',
      promptSave: false
    }
  },
  computed: {
    ...mapGetters(['checkAccess']),
    startDateValidation() {
      return 'accept_today_date:' + this.insuredForm.coRegDate
    },
    gstDateValidation() {
      return 'accept_today_date:' + this.insuredForm.gstRegDate
    },
    getInsuredForm() {
      return this.$store.state.adminInsured.insured
    },
    insuredClientGrpList() {
      let result = []
      Object.keys(insuredClientGrp).forEach(function (key) {
        const status = insuredClientGrp[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    insuredTitleList() {
      let result = []
      Object.keys(insuredTitle).forEach(function (key) {
        const status = insuredTitle[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    insuredGenderList() {
      let result = []
      Object.keys(insuredGender).forEach(function (key) {
        const status = insuredGender[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    }
  },
  methods: {
    ...mapActions(['insuredMenuInit']),
    doInit() {
      // Default value from vuex store 1st
      if (this.getInsuredForm.clientGrp === 'I') {
        this.boolClientGrpI = false
        this.boolClientGrpC = true
      } else if (this.getInsuredForm.clientGrp === 'C') {
        this.boolClientGrpI = true
        this.boolClientGrpC = false
      } else {
        this.boolClientGrpI = false
        this.boolClientGrpC = false
      }
      if (this.getInsuredForm.insdRefNoAe) {
        this.insuredForm.insdRefNoAe = this.getInsuredForm.insdRefNoAe
      } else {
        this.insuredForm.insdRefNoAe = false
      }
      this.insuredForm.insdRefNo = this.getInsuredForm.insdRefNo
      this.insuredForm.clientGrp = this.getInsuredForm.clientGrp
      this.insuredForm.clientType = this.getInsuredForm.clientType
      this.insuredForm.titleName = this.getInsuredForm.titleName
      this.insuredForm.name1 = this.getInsuredForm.name1
      this.insuredForm.name2 = this.getInsuredForm.name2
      this.insuredForm.name3 = this.getInsuredForm.name3
      this.insuredForm.name4 = this.getInsuredForm.name4
      this.insuredForm.fullName = this.getInsuredForm.fullName
      this.insuredForm.abbrevName = this.getInsuredForm.abbrevName
      this.insuredForm.address1 = this.getInsuredForm.address1
      this.insuredForm.address2 = this.getInsuredForm.address2
      this.insuredForm.address3 = this.getInsuredForm.address3
      this.insuredForm.address4 = this.getInsuredForm.address4
      this.insuredForm.address5 = this.getInsuredForm.address5
      this.insuredForm.address6 = this.getInsuredForm.address6
      this.insuredForm.postalCode = this.getInsuredForm.postalCode
      this.insuredForm.contact = this.getInsuredForm.contact
      this.insuredForm.telNo1 = this.getInsuredForm.telNo1
      this.insuredForm.telNo2 = this.getInsuredForm.telNo2
      this.insuredForm.telNo3 = this.getInsuredForm.telNo3
      this.insuredForm.telNo4 = this.getInsuredForm.telNo4
      this.insuredForm.telNo5 = this.getInsuredForm.telNo5
      this.insuredForm.email = this.getInsuredForm.email
      this.insuredForm.web = this.getInsuredForm.web
      this.insuredForm.gender = this.getInsuredForm.gender
      if (this.getInsuredForm.dob) {
        this.insuredForm.dob = this.getInsuredForm.dob
      }
      this.insuredForm.icNo = this.getInsuredForm.icNo
      if (this.getInsuredForm.inactive) {
        this.insuredForm.inactive = this.getInsuredForm.inactive
      } else {
        this.insuredForm.inactive = false
      }
      if (this.getInsuredForm.blackList) {
        this.insuredForm.blackList = this.getInsuredForm.blackList
      } else {
        this.insuredForm.blackList = false
      }
      if (this.getInsuredForm.chgNAPol) {
        this.insuredForm.chgNAPol = this.getInsuredForm.chgNAPol
      } else {
        this.insuredForm.chgNAPol = false
      }
      this.insuredForm.insdBillAcct = this.getInsuredForm.insdBillAcct
      this.insuredForm.grpRefStmt = this.getInsuredForm.grpRefStmt
      this.insuredForm.grpRefAge = this.getInsuredForm.grpRefAge
      this.insuredForm.grpRefStats = this.getInsuredForm.grpRefStats
      this.insuredForm.gstRegNo = this.getInsuredForm.gstRegNo
      if (this.getInsuredForm.gstRegDate) {
        this.insuredForm.gstRegDate = this.getInsuredForm.gstRegDate
      }
      this.insuredForm.coRegNo = this.getInsuredForm.coRegNo
      if (this.getInsuredForm.coRegDate) {
        this.insuredForm.coRegDate = this.getInsuredForm.coRegDate
      }
      this.insuredForm.createdBy = this.getInsuredForm.strCreatedBy
      this.insuredForm.modifiedBy = this.getInsuredForm.strModifiedBy
      if (this.getInsuredForm.createdDate) {
        this.insuredForm.createdDate = this.getInsuredForm.createdDate
      }
      if (this.getInsuredForm.modifiedDate) {
        this.insuredForm.modifiedDate = this.getInsuredForm.modifiedDate
      }
      this.insuredForm.createdProgId = this.getInsuredForm.createdProgId
    },
    async setDob() {
      var date = new Date()
      date.setFullYear(date.getFullYear() - 25)
      this.insuredForm.dob = date
    },
    async getClientTypeList() {
      const apiURI = this.$store.state.adminInsured.menu.clientTypeList
      try {
        const result = await this.$http.get(apiURI)
        const { data } = result
        if (data) {
          this.clientTypeList = data.data
        }
      } catch (err) {
        throw err
      }
    },
    async getInsuredCtyList() {
      const apiURI = this.$store.state.adminInsured.menu.countryList
      try {
        const result = await this.$http.get(apiURI)
        const { data } = result.data
        if (data) {
          this.insuredCountryList = data
        }
      } catch (err) {
        throw err
      }
    },
    async doInsuredAddress() {
      const apiUrl = this.$store.state.adminInsured.menu.address
      if (apiUrl) {
        try {
          this.InsuredPostalCodeLoading = true
          const expand = {
            postCode: this.insuredForm.postalCode
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          const { data } = result
          if (data) {
            this.insuredForm.address1 = data.add1
            this.insuredForm.address2 = data.add2
            this.insuredForm.address3 = ''
            this.insuredForm.address4 = ''
          }
          this.InsuredPostalCodeLoading = false
        } catch (err) {
          this.InsuredPostalCodeLoading = false
          const { data } = err.response
          if (data) {
            this.promptPostalCode = true
            // this.notify(data)
          }
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async valIcNo() {
      if (this.insuredForm.icNo !== null) {
        // if not a valid prefix, return false
        var prefix = this.insuredForm.icNo.charAt(0).toUpperCase()
        if (prefix !== 'S' && prefix !== 'T' && prefix !== 'F' && prefix !== 'G') {
          this.promptIcNo = true
        }

        var uin = ['J', 'Z', 'I', 'H', 'G', 'F', 'E', 'D', 'C', 'B', 'A']
        var fin = ['X', 'W', 'U', 'T', 'R', 'Q', 'P', 'N', 'M', 'L', 'K']
        var weightArray = [2, 7, 6, 5, 4, 3, 2]
        var weight = 0
        var lastAlphabet = null

        var icArray = this.insuredForm.icNo.split('')

        // return false if position 2-8 of nric is not a number
        try {
          for (var i = 1; i < 8; i++) {
            weight += parseInt(icArray[i], 10) * weightArray[i - 1]
          }
        } catch (ex) {
          this.promptIcNo = true
        }

        // calculate last alphabet
        var offset = icArray[0] === 'T' || icArray[0] === 'G' ? 4 : 0
        var temp = (offset + weight) % 11

        if (icArray[0] === 'S' || icArray[0] === 'T') {
          lastAlphabet = uin[temp]
        } else if (icArray[0] === 'F' || icArray[0] === 'G') {
          lastAlphabet = fin[temp]
        }

        if ((icArray[8] === lastAlphabet) === false) {
          this.promptIcNo = true
        }

        // 2020-08-28 LYT Added Sanction Validation
        this.valSanction('', this.insuredForm.icNo, 'sanctionDocNoError')
      }
    },
    async getInterList() {
      const apiURI = this.$store.state.adminInsured.menu.interList
      try {
        const result = await this.$http.get(apiURI)
        const { data } = result.data
        if (data) {
          this.interList = data
        }
      } catch (err) {
        throw err
      }
    },
    doBack() {
      this.$router.push({ name: 'insureds' })
    },
    doPromptSave() {
      this.promptSave = true
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.newInsured) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doUpdate() {
      const apiURI = this.$store.state.adminInsured.insured.menu.updateInsured
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.put(apiURI, this.insuredForm)
          const { data } = result
          if (data) {
            // Show message via notify
            this.notify(data)
            this.$store.dispatch('insuredMenuInit', this.insuredForm.insdRefNo)
            this.$router.push({ name: 'insureds' })
            // Redirect back to listing
            // this.$router.push({ name: 'reviewDetails' })
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async doCreate() {
      const apiURI = this.$store.state.adminInsured.menu.createInsured
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.insuredForm)
          const { data } = result
          if (data) {
            // Show message via notify
            this.notify(data)
            if (this.insuredForm.insdRefNo == null) {
              this.insuredForm.insdRefNo = data.insdRefNo
            }
            this.$store.dispatch('insuredMenuInit', this.insuredForm.insdRefNo)
            this.newInsured = false
            this.$router.push({ name: 'insureds' })
            // this.$router.push({ name: 'reviewDetails', params: { inter: this.interForm.inter } })
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
            this.notify(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async doCancelPostalCode() {
      this.insuredForm.address1 = null
      this.insuredForm.address2 = null
      this.insuredForm.address4 = null
      this.insuredForm.postalCode = null
    },
    async doCancelIcNo() {
      this.insuredForm.icNo = null
    },
    doInsdRefNoAe() {
      if (this.insuredForm.insdRefNoAe) {
        this.insuredForm.insdRefNo = null
        this.insuredForm.insdRefNoAe = true
        this.errors.remove('insdRefNo')
      }
    },
    doClientGrp() {
      if (this.insuredForm.clientGrp === 'I') {
        // this.insuredForm.coRegNo = undefined
        this.boolClientGrpI = false
        this.boolClientGrpC = true
      } else if (this.insuredForm.clientGrp === 'C') {
        // this.insuredForm.icNo = undefined
        this.boolClientGrpI = true
        this.boolClientGrpC = false
      }
      this.panel = []
    },
    formatDate(xDate) {
      if (xDate === null) {
        return undefined
      } else {
        return formatDisplayDate(xDate)
      }
    },
    assignInsuredInfo(data) {
      if (data.insuredFieldKey === 'GS1') {
        this.insuredForm.grpRefStmt = data.insdRefNo
      } else if (data.insuredFieldKey === 'GS2') {
        this.insuredForm.grpRefStats = data.insdRefNo
      } else if (data.insuredFieldKey === 'GA1') {
        this.insuredForm.grpRefAge = data.insdRefNo
      }
    },
    doShowInsuredList(insKey) {
      this.showInsuredHelpList = true
      this.insuredFieldKey = insKey
    }
  },
  created() {
    Promise.all([this.getInsuredCtyList(), this.getInterList(), this.doClientGrp(), this.getClientTypeList(), this.setDob()])
    if (this.insdRefNo === 'new') {
      this.newInsured = true
      this.insuredForm.dob = undefined
      this.insuredForm.gender = ''
    } else {
      this.doInit()
    }
  },
  props: ['insdRefNo', 'clientType'],
  mixins: [MessageMixin, commonAjaxMixin],
  components: {
    InsuredHelpList,
    SanctionPartialMatchList
  }
}
</script>

<style lang="scss">
</style>
